import request from '@/utils/request'

//登录接口
export function login(data) {
  return request({
    url: '/login',
    method: 'post',
    data
  })
}

// 退出
export function loginOut() {
  return request({
    url: '/logout',
    method: 'get',
  })
}

// 清除缓存
export function clearTrash() {
  return request({
      url: '/clear_trash',
      method: 'get',
  })
}


// 获取管理员详情
export function getadmininfo() {
  return request({
      url: '/getadmininfo',
      method: 'get',
  })
}

// 登录时,,后台返回跳转
export function adminRole() {
  return request({
      url: '/admin_role',
      method: 'get',
  })
}